import { useEffect, useState } from 'react';
import { getCalcomEventTypes } from 'src/services/client';
import { ICalcomEventType } from 'src/pages/Calendar/CalcomIntegration/types';

export interface IUseCalcomEventTypes {
  eventTypes: ICalcomEventType[];
  isLoading: boolean;
  error: string | null;
  // True only once we know the fetch succeeded and the user genuinely has zero event types — the
  // signal the UI uses to show the "create one in Cal.com" dead-end instead of an empty dropdown.
  hasNoEventTypes: boolean;
  refetch: () => Promise<void>;
}

export const useCalcomEventTypes = (): IUseCalcomEventTypes => {
  const [eventTypes, setEventTypes] = useState<ICalcomEventType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEventTypes = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    const result = await getCalcomEventTypes();

    if (!result.ok) {
      setError(result.error ?? 'Failed to fetch Cal.com event types');
      setIsLoading(false);
      return;
    }

    setEventTypes(result.data ?? []);
    setIsLoading(false);
  };

  const hasNoEventTypes: boolean =
    !isLoading && error === null && eventTypes.length === 0;

  useEffect(() => {
    void fetchEventTypes();
  }, []);

  return {
    eventTypes,
    isLoading,
    error,
    hasNoEventTypes,
    refetch: fetchEventTypes,
  };
};